<template>
	<div class="gift-body">
		<div class="container-box">
			<div class="order-menu">
				<span>
					<i class="el-icon-back" @click="goBack"></i>
				</span>{{preSaleId !== '' ? '编辑预售' : '新增预售'}}
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					活动编号：
				</div>
				<div class="gift-row-content">
					{{code}}
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					活动名称：
				</div>
				<div class="gift-row-content">
					<el-input v-model="name" maxlength="30" :disabled="isDisable" size="mini" placeholder="不超过30字"></el-input>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					活动时间：
				</div>
				<div class="gift-row-content">
					<el-date-picker
						:disabled="isDisable"
						v-model="dateValue"
						:clearable="false"
						:unlink-panels='true'
						class="time-input"
						size="mini"
						type="datetimerange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						:default-time="['00:00:00', '23:59:59']"
						format='yyyy-MM-dd HH:mm:ss'
						value-format='yyyy-MM-dd HH:mm:ss'>
					</el-date-picker>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					活动状态：
				</div>
				<div class="gift-row-content">
					<el-switch size='mini' :disabled="isDisable" v-model="disabledflag" active-color="#E9EAEB" inactive-color="var(--fx-primary-color)">
					</el-switch>
					<span style="margin-left:10px">{{disabledflag ? '停用' : '启用'}}</span>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					售卖方式：
				</div>
				<div class="gift-row-content">
					<el-radio :disabled="isDisable" v-model="onlypresaleflag" :label="0">预售+正常售卖</el-radio>
					<el-radio :disabled="isDisable" v-model="onlypresaleflag" :label="1">仅预售</el-radio>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					适用客户：
				</div>
				<div class="gift-row-content" style="width:400px">
					<el-radio :disabled="isDisable" v-model="attendway" :label="0">全部客户</el-radio>
					<el-radio :disabled="isDisable" v-model="attendway" :label="1">自定义客户</el-radio>
					<span v-if="attendway === 1 && !isDisable" @click="addCusClick" style="margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
						<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
						选择客户
					</span>
				</div>
			</div>
			<div v-if="attendway === 1" class="customer-box" style="font-size: 13px;">
				<span>已选：</span>
				{{cusText}}
			</div>
			<div>
				<div style="display: flex;align-items: center;height: 40px;">
					<div style="width:120px;text-align: right;font-size: 13px;">
						<span style="color:#EE4F31">*</span>适用门店：
					</div>
					<el-radio :disabled="isDisable" style="min-height: 40px;;line-height: 40px;" v-model="shopattendway" :label="0">全部门店</el-radio>
					<el-radio :disabled="isDisable" style="min-height: 40px;;line-height: 40px;" v-model="shopattendway" :label="1">自定义门店</el-radio>
					<div  v-if="shopattendway === 1 && !isDisable" @click="bindShopClick" style="height: 20px;line-height: 20px;margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
						<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
						选择门店
					</div>
				</div>
				<div v-if="shopattendway === 1" style="display: flex;align-items: center;min-height: 40px;font-size: 13px;">
					<div style="width:120px;text-align: right;">
						已选：
					</div>
					<div>{{shopText}}</div>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					预计发货时间：
				</div>
				<div class="gift-row-content">
					<el-date-picker
						:disabled="isDisable"
						v-model="dateValue1"
						:clearable="false"
						:unlink-panels='true'
						class="time-input"
						size="mini"
						type="datetimerange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						:default-time="['00:00:00', '23:59:59']"
						format='yyyy-MM-dd HH:mm:ss'
						value-format='yyyy-MM-dd HH:mm:ss'>
					</el-date-picker>
				</div>
				<span style="color:#EE4F31;margin-left:20px">预计发货时间需大于活动截止时间！</span>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					预售明细：
				</div>
			</div>
			<div class="pro-btn-box">
				<div style="margin-left:40px">
					<el-button size="mini" v-if="!isDisable" @click="addProClick" plain type="primary" icon='el-icon-plus'>新增</el-button>
					<el-button size="mini" v-if="!isDisable" @click="delMutiProClick" plain >删除</el-button>
					<el-button size="mini" v-if="!isDisable" @click="clearProClick" plain>清空</el-button>
					<el-button size="mini" v-if="!isDisable" @click="mutiClick" plain>修改预售方案</el-button>
				</div>
				<div style="width:300px;display:flex;margin-right:20px">
					<el-input v-model="searchProName" size="mini" placeholder="请输入内容" @keyup.enter.native="proSearch"></el-input>
					<el-button style="margin-left:10px" size="mini" type="primary" @click="proSearch">查询</el-button>
				</div>
			</div>
				<el-table
				:stripe='true'
				size='mini'
				:data="proTableData"
				@selection-change="handleSelectionChange"
				border>
					<el-table-column
						type="selection"
						align="center"
						width="55">
					</el-table-column>
					<el-table-column
						prop="productname"
						label="商品名称"
						align="center"
						min-width="120">
						<template slot-scope='scope'>
							<div>{{scope.row.productname}}</div>
							<div>{{scope.row.productcode}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="productcode"
						label="商品规格"
						align="center"
						min-width="100">
						<template slot-scope='scope'>
							<div>{{scope.row.spec}}</div>
							<div>{{scope.row.speccode}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="price"
						label="价格（元）"
						align="center"
						min-width="80">
						<template slot-scope='scope'>
							<div>{{scope.row.price === -1 ? '' : scope.row.price}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="preprice"
						label="预售价格（元）"
						align="center"
						min-width="160">
						<template slot-scope='scope'>
							<el-input :disabled="isDisable" style="width: 80%;" @input='checkPrice(scope.row)' @blur="blurPrice(scope.row)" v-model="scope.row.preprice" size="mini"></el-input>
						</template>
					</el-table-column>
					<el-table-column
						prop="preamount"
						label="预售数量上限"
						align="center"
						min-width="160">
						<template slot-scope='scope'>
							<el-input :disabled="isDisable" style="width: 80%;" @input='checkNum(scope.row)' @blur="blurNum(scope.row)" v-model="scope.row.preamount" size="mini"></el-input>
						</template>
					</el-table-column>
					<el-table-column v-if="!isDisable" label="操作" min-width="100" align="center">
						<template slot-scope="scope">
							<el-button type='text' size="mini" @click='delClick(scope.row.productid)'>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
		</div>
		<div style="height:60px;line-height:60px;width:100%;text-align:center">
			<el-button size="mini" v-if="!isDisable" type="primary" @click='saveClick'>保存</el-button>
		</div>
		<el-dialog
			title="选择活动对象"
			:visible.sync="customerDialog"
			class="dialog-title"
			width="780px"
			top="60px"
			:close-on-click-modal="false">
			<div class="dialog-body">
				<bind-customer v-if="customerDialog" :customerDialog.sync="customerDialog" @reloadCus='reloadCus' :customertype='customertype' :chooseCusByCate='chooseCusByCate' :chooseCusBylevel='chooseCusBylevel'></bind-customer>
			</div>
		</el-dialog>
		<el-dialog
			title="提示"
			class="dialog-title"
			:visible.sync="showError"
			width="30%">
			<div style="width: 100%;max-height: 300px;overflow-y:auto ;">
				<div style="padding: 5px 10px;text-align: left;" v-for="(item,index) in errorList" :key='index'>
					【{{item.customername}}】在【{{item.name}}】的买赠活动中已绑定关系！
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" size="mini" @click="showError = false">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog
			top='100px'
			title="选择适用门店"
			class="dialog-title"
			:visible.sync="shopDialog"
			width="780px"
			append-to-body
			:close-on-click-modal="false">
			<div>
				<bindShop v-if="shopDialog" :customerDialog.sync='shopDialog' :chooseData1='chooseShop' @reloadCus='reloadShop'></bindShop>
			</div>
		</el-dialog>
		<el-dialog
			title="预售商品明细"
			:visible.sync="productDialog"
			class="dialog-title"
			width="1080px"
			top="60px"
			:close-on-click-modal="false">
			<div class="dialog-body">
				<bindProduct v-if="productDialog" :decimal='decimal' :productDialog.sync="productDialog" @reloadPro='reloadPro' :chooseProAll='chooseProAll'></bindProduct>
			</div>
		</el-dialog>
		<el-dialog
			title="批量修改预售方案"
			:visible.sync="mutiDialog"
			class="dialog-title"
			width="880px"
			top="60px"
			:close-on-click-modal="false">
			<div class="dialog-body">
				<div class="container-box1">
					<div class="row-box">
						<div style="min-width:150px">
							设置预售价格：
						</div>
						<el-radio style="min-height: 40px;;line-height: 40px;" v-model="priceType" :label="0">按原价增加</el-radio>
						<el-input style="width:100px;" v-model="upNum" @blur="upNumBlur" @input="upNumCheck" size="mini"></el-input>%
						<el-radio style="min-height: 40px;line-height: 40px;margin-left:50px" v-model="priceType" :label="1">原价下降</el-radio>
						<el-input style="width:100px" v-model="downNum" @blur="downNumBlur" @input="downNumCheck" size="mini"></el-input>%
					</div>
					<div class="row-box" style="color:#EE4F31">备注：最终计算后的价格进行“四舍五入”，与系统参数设置无关！</div>
					<div class="row-box">
						<div style="min-width:150px">
							设置预售数量：
						</div>
						<el-radio style="min-height: 40px;;line-height: 40px;" v-model="numType" :label="0">上限值</el-radio>
						<el-input @input='mutiCheckNum' @blur="mutiBlurNum" style="width:100px;margin-right:10px" v-model="maxNum" size="mini"></el-input>
						<el-radio style="min-height: 40px;;line-height: 40px;" v-model="numType" :label="1">不限</el-radio>
					</div>
					<div class="row-box" style="color:#EE4F31">备注：此处预售数量需要按系统参数设置支持输入小数位数！</div>
				</div>
				<div style="width: 100%;height: 50px;text-align: right;">
					<el-button @click='closeClick' size='mini'>取消</el-button>
					<el-button @click='saveMutiClick' size='mini' type="primary">确定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import BindCustomer from './bindCustomer.vue'
import bindProduct from './bindProduct.vue'
import bindShop from '@/components/bindShop/bindShop.vue'
export default {
	name: 'preSela',
	components: {
		BindCustomer,
		bindShop,
		bindProduct
	},
	data () {
		return {
			priceType: 0,
			numType: 0,
			maxNum: 0,
			upNum: 0,
			downNum: 0,
			searchProName: '',
			proIds: [],
			preSaleId: '',
			onlypresaleflag: 0,
			chooseProAll: [],
			proTableData: [],
			productDialog: false,
			AuthorityList: {
				'08_0004_0001_00': false,
				'08_0004_0002_00': false,
				'08_0004_0003_00': false,
				'08_0004_0004_00': false
			},
			showError: false,
			errorList: [],
			cusText: '',
			productPagination: {
				page: 1,
				size: 20
			},
			disabledflag: false,
			product: null,
			name: '',
			type: 0,
			code: '',
			attendway: 0,
			dateValue: [],
			dateValue1: [],
			customerDialog: false,
			chooseCusByCate: [],
			chooseCusBylevel: [],
			chooseCus: [],
			customertype: 0,
			decimal: 0,
			isDisable: true,
			shopattendway: 0,
			shopDialog: false,
			mutiDialog: false,
			shopText: '',
			chooseShop: []
		}
	},
	created () {
		this.getAuthority('08_0004_0000_00')
		this.getOrderSystemSetting()
		let id = window.sessionStorage.getItem('preSaleId')
		if (id) {
			this.preSaleId = id
			this.getDetail()
		}
	},
	methods: {
		saveMutiClick () {
			let list = this.proIds.map(item => {
				return item.productattrplanid
			})
			let proList = []
			this.chooseProAll.forEach(item => {
				if (list.indexOf(item.productattrplanid) !== -1) {
					if (this.priceType === 0) {
						item.preprice = +item.price + (+this.upNum * +item.price * 0.01)
					} else {
						item.preprice = +item.price - (+this.downNum * +item.price * 0.01)
					}
					if (this.numType === 0) {
						item.preamount = this.maxNum
					} else {
						item.preamount = ''
					}
					item.preprice = this.$fxUtils.toFixedSHW(item.preprice, 2)
					proList.push(item)
				} else {
					proList.push(item)
				}
			})
			this.chooseProAll = proList
			this.proSearch()
			this.mutiDialog = false
		},
		downNumCheck () {
			this.downNum = this.downNum.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.downNum = this.downNum.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.downNum = this.downNum.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.downNum = this.downNum.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
		},
		downNumBlur () {
			if (this.downNum === '') {
				this.downNum = 0.00
			} else {
				if (+this.downNum > 100) {
					this.downNum = 100.00
				}
				this.downNum = this.$fxUtils.toFixedSHW(this.downNum, 2)
			}
		},
		upNumCheck () {
			this.upNum = this.upNum.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.upNum = this.upNum.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.upNum = this.upNum.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.upNum = this.upNum.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
		},
		upNumBlur () {
			if (this.upNum === '') {
				this.upNum = 0.00
			} else {
				if (+this.upNum > 100) {
					this.upNum = 100.00
				}
				this.upNum = this.$fxUtils.toFixedSHW(this.upNum, 2)
			}
		},
		mutiCheckNum () {
			this.maxNum = this.maxNum.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.maxNum = this.maxNum.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.maxNum = this.maxNum.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.maxNum = this.maxNum.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			switch (this.decimal) {
			case 0:
				this.maxNum = this.maxNum.replace(/(^[0]|[^\d])/g, '')
				break
			case 1:
				this.maxNum = this.maxNum.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
				break
			case 2:
				this.maxNum = this.maxNum.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				break
			case 3:
				this.maxNum = this.maxNum.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				break
			case 4:
				this.maxNum = this.maxNum.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
				break
			}
		},
		mutiBlurNum () {
			if (this.maxNum === '' || this.maxNum === null || +this.maxNum === 0) {
				return false
			}
			this.maxNum = +this.maxNum
			if (this.maxNum > 10000 || this.maxNum === 10000) {
				switch (this.decimal) {
				case 0:
					this.maxNum = 9999
					break
				case 1:
					this.maxNum = 9999.9
					break
				case 2:
					this.maxNum = 9999.99
					break
				case 3:
					this.maxNum = 9999.999
					break
				case 4:
					this.maxNum = 9999.9999
					break
				}
			}
		},
		closeClick () {
			this.mutiDialog = false
		},
		proSearch () {
			let arr = []
			this.chooseProAll.forEach(item => {
				if (item.productname.indexOf(this.searchProName) !== -1) {
					arr.push(item)
				}
			})
			this.proTableData = arr
		},
		handleSelectionChange (val) {
			this.proIds = val
		},
		mutiClick () {
			if (this.proIds.length === 0) {
				this.$message.error('至少选择一个商品')
				return false
			}
			this.priceType = 0
			this.numType = 0
			this.maxNum = 0
			this.upNum = 0
			this.downNum = 0
			this.mutiDialog = true
		},
		delMutiProClick () {
			if (this.proIds.length === 0) {
				this.$message.error('至少选择一个商品')
				return false
			}
			let list = this.proIds.map(item => {
				return item.productid
			})
			let arr = []
			if (list.length > 0) {
				arr = Array.from(new Set(list))
			}
			let proList = []
			this.chooseProAll.forEach(item => {
				if (arr.indexOf(item.productid) === -1) {
					proList.push(item)
				}
			})
			this.chooseProAll = proList
			this.proSearch()
		},
		clearProClick () {
			this.searchProName = ''
			this.proTableData = []
			this.chooseProAll = []
		},
		reloadPro (data) {
			let ids = data.ids.map(item => {
				return item.id
			})
			let params = {
				ids: ids.join(',')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/product/getProductSpecInfo4Presale`,
				data: params
			}).then(res => {
				if (res.result) {
					this.productDialog = false
					if (res.data.length > 0) {
						this.initProData(res.data, data)
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		initProData (list, data) {
			let arr = []
			list.forEach(item => {
				let row = {
					productattrplanid: item.productattrplanid,
					productid: item.id,
					productcode: item.productCode,
					productname: item.productName,
					spec: item.spec,
					speccode: item.code,
					price: item.price
				}
				if (item.price !== -1) {
					if (data.priceType === 0) {
						row.preprice = +item.price + (+data.upNum * +item.price * 0.01)
					} else {
						row.preprice = +item.price - (+data.downNum * +item.price * 0.01)
					}
					row.preprice = this.$fxUtils.toFixedSHW(row.preprice, 2)
				} else {
					row.preprice = ''
				}
				if (data.numType === 0) {
					row.preamount = data.maxNum
				} else {
					row.preamount = ''
				}
				arr.push(row)
			})
			let allArr = this.chooseProAll.concat(arr)
			this.searchProName = ''
			this.proTableData = allArr
			this.chooseProAll = allArr
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
					let id = window.sessionStorage.getItem('preSaleId')
					if (id) {
						this.isDisable = !this.AuthorityList['08_0004_0002_00']
					} else {
						this.isDisable = !this.AuthorityList['08_0004_0003_00']
					}
				}
			})
		},
		getOrderSystemSetting () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/getOrderSystemSetting`
			}).then(res => {
				if (res.result) {
					this.decimal = res.data.orderdecimalcount
				} else {
					this.$message.error(res.msg)
				}
			}).catch((res) => {
				this.$message.error(res.msg)
			})
		},
		blurNum (row) {
			if (row.preamount === '' || row.preamount === null || +row.preamount === 0) {
				return false
			}
			row.preamount = +row.preamount
			if (row.preamount > 10000 || row.preamount === 10000) {
				switch (this.decimal) {
				case 0:
					row.preamount = 9999
					break
				case 1:
					row.preamount = 9999.9
					break
				case 2:
					row.preamount = 9999.99
					break
				case 3:
					row.preamount = 9999.999
					break
				case 4:
					row.preamount = 9999.9999
					break
				}
			}
		},
		blurPrice (row) {
			if (row.preprice === '') {
				if (row.price !== -1) {
					row.preprice = row.price
				}
			} else {
				if (+row.preprice > 100000) {
					row.preprice = 99999.99
				}
				row.preprice = this.$fxUtils.toFixedSHW(row.preprice, 2)
			}
		},
		checkPrice (row) {
			row.preprice = row.preprice.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			row.preprice = row.preprice.replace(/^\./g, '')// 验证第一个字符是数字而不是
			row.preprice = row.preprice.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			row.preprice = row.preprice.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
		},
		checkNum (row) {
			row.preamount = row.preamount.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			row.preamount = row.preamount.replace(/^\./g, '')// 验证第一个字符是数字而不是
			row.preamount = row.preamount.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			row.preamount = row.preamount.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			switch (this.decimal) {
			case 0:
				row.preamount = row.preamount.replace(/(^[0]|[^\d])/g, '')
				break
			case 1:
				row.preamount = row.preamount.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
				break
			case 2:
				row.preamount = row.preamount.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				break
			case 3:
				row.preamount = row.preamount.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				break
			case 4:
				row.preamount = row.preamount.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
				break
			}
		},
		reloadCus (data) {
			this.chooseCus = data.chooseData
			this.customertype = data.customertype
			if (this.customertype === 0) {
				this.chooseCusByCate = this.chooseCus
			} else {
				this.chooseCusBylevel = this.chooseCus
			}
			this.initCusData()
			this.customerDialog = false
		},
		checkCusNum (data) {
			let num = 0
			data.forEach(item => {
				if (item.id !== '-1') {
					num++
				}
			})
			return num
		},
		initCusData () {
			let textArr = []
			let list = this.chooseCus
			list.forEach(item => {
				let itemText = ''
				if (item.categoryOrLevelFlag === 1) {
					itemText = item.name + '（整类）'
				} else {
					itemText = item.name + '（' + this.checkCusNum(item.cus) + '个）'
				}
				textArr.push(itemText)
			})
			this.cusText = textArr.join('，')
		},
		initShopData (data) {
			let textArr = []
			let ids = []
			data.forEach(item => {
				ids.push(item.shopid)
				textArr.push(item.shopname)
			})
			this.shopText = textArr.join('，')
			this.chooseShop = ids
		},
		str2Time (date) {
			return new Date(date).getTime()
		},
		checkSave () {
			if (this.name === '') {
				this.$message.error('请填写活动名称')
				return false
			}
			if (this.dateValue === null || this.dateValue.length === 0) {
				this.$message.error('请选择活动时间')
				return false
			}
			if (this.dateValue1 === null || this.dateValue1.length === 0) {
				this.$message.error('请选择活动时间预计发货时间')
				return false
			}
			if (this.str2Time(this.dateValue1[0]) < this.str2Time(this.dateValue[1])) {
				this.$message.error('预计发货时间需大于活动截止时间！')
				return false
			}
			if (this.shopattendway === 1 && this.chooseShop.length === 0) {
				this.$message.error('请选择适用门店')
				return false
			}
			if (this.attendway === 1 && this.chooseCus.length === 0) {
				this.$message.error('至少选择一个客户')
				return false
			}
			if (this.chooseProAll.length === 0) {
				this.$message.error('至少选择一个商品')
				return false
			}
			for (let i = 0; i < this.chooseProAll.length; i++) {
				if (this.chooseProAll[i].preprice === '') {
					this.$message.error('请填写预售价格')
					return false
				}
			}
			return true
		},
		saveClick () {
			if (!this.checkSave()) {
				return false
			}
			let params = {
				id: this.preSaleId,
				name: this.name,
				attendway: this.attendway,
				beginDate: this.dateValue[0],
				endDate: this.dateValue[1],
				presaleBeginDate: this.dateValue1[0],
				presaleEndDate: this.dateValue1[1],
				onlypresaleflag: this.onlypresaleflag,
				customertype: this.customertype,
				customerDetail: this.chooseCus,
				shopIds: this.chooseShop,
				disabledflag: this.disabledflag,
				shopattendway: this.shopattendway,
				detail: this.chooseProAll
			}
			let logger = null
			let id = window.sessionStorage.getItem('preSaleId')
			if (id) {
				logger = this.$fxLogger.createInfo('discount.presale_info.update', { name: params.name, code: this.code })
			} else {
				logger = this.$fxLogger.createInfo('discount.presale_info.add', { name: params.name })
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/saveorupdate4presale`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.preSaleId = res.data
					window.sessionStorage.setItem('preSaleId', res.data)
					this.getDetail()
					this.getAuthority('08_0004_0000_00')
					this.$message.success('保存成功!')
				} else {
					if (res.code === 1) {
						this.errorList = []
						this.errorList = res.data
						this.showError = true
						return false
					}
					this.$message.error(res.msg)
				}
			})
		},
		addCusClick () {
			this.customerDialog = true
		},
		getDetail () {
			let params = {
				id: this.preSaleId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/getdetail4presale`,
				data: params
			}).then(res => {
				if (res.result) {
					let data = res.data
					this.shopattendway = data.discount.shopattendway
					this.customertype = data.presale.customertype
					let cusList = data.customerList
					cusList.forEach(item => {
						item.name = this.customertype === 0 ? item.categoryname : item.levelname
						item.id = this.customertype === 0 ? item.categoryid : item.levelid
						item.showCus = 1
					})
					cusList = JSON.parse(JSON.stringify(cusList))
					this.chooseCus = cusList
					if (this.customertype === 0) {
						this.chooseCusBylevel = []
						this.chooseCusByCate = cusList
					} else {
						this.chooseCusBylevel = cusList
						this.chooseCusByCate = []
					}
					this.dateValue = [data.discount.begindate, data.discount.enddate]
					this.dateValue1 = [data.presale.begindate, data.presale.enddate]
					this.onlypresaleflag = data.presale.onlypresaleflag
					this.name = data.discount.name
					this.attendway = data.discount.attendway
					this.disabledflag = data.discount.disabledflag
					this.code = data.discount.code
					this.preSaleId = data.discount.id
					let list = data.productList
					list.forEach(item => {
						if (item.preamountflag) {
							item.preamount = ''
						}
						if (item.preprice === -1) {
							item.preprice = ''
						}
					})
					this.searchProName = ''
					this.chooseProAll = list
					this.proTableData = list
					this.initCusData()
					this.initShopData(data.shops)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		delClick (id) {
			let arr = []
			this.chooseProAll.forEach((item, i) => {
				if (item.productid !== id) {
					arr.push(item)
				}
			})
			this.chooseProAll = arr
			this.proSearch()
			this.proTableData = arr
		},
		goBack () {
			this.$fxEventBus.$emit('setMenu', '9-4')
			this.$router.push('preSaleList')
		},
		addProClick () {
			this.productDialog = true
		},
		bindShopClick () {
			this.shopDialog = true
		},
		reloadShop (data) {
			this.chooseShop = data.chooseData
			this.shopText = data.shopText
			this.shopDialog = false
		}
	}
}
</script>
<style lang="stylus" scoped>

.gift-body{
    min-width :1000px;
    width :100%;
    height :100%;
    overflow :hidden;
    padding-bottom :50px;
    border-radius :0px 0px 10px 10px;
	.container-box{
		height:calc(100% - 60px);
		overflow:auto
	}
	.order-menu {
		height: 50px
		line-height: 50px
		text-align: left
		font-size: 15px
		border-bottom: 1px solid #dce1fe
		box-sizing: border-box
		span {
			display: inline-block;
			line-height: 50px;
			padding-right: 10px;
			i {
				border-radius: 50%;
				background: #9da6af;
				padding: 3px;
				cursor: pointer;
			}
			.el-icon-back:before {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
	}
	.customer-box{
		line-height 40px;
		padding-left :81px;
		padding-right :20px;
		text-align :left;
		box-sizing :border-box;
	}
	.gift-row{
		min-height :40px;
		display :flex;
		flex-direction :row;
		align-items :center;
		.gift-row-title{
			width :120px;
			height :40px;
			display :flex;
			align-items :center;
			font-size :13px;
			justify-content: flex-end;
		}
		.gift-row-content{
			width :400px;
			height:40px;
			display :flex;
			align-items :center;
			text-align :left
		}
		.condition-des {
			color:#EE4F31;
			text-align:left;
			margin-bottom: 5px
		}
	}
	.main-product-box{
		text-align: left;
	}
	.product-name-box{
		display:inline-block;
		background-color:#eceffc;
		padding:0px 10px;
		line-height:30px;
		margin-left:10px;
		border-radius: 4px;
	}
	.filters-container {
		display: flex;
		flex-direction: row;
		height: 50px;
		align-items: center;
		margin-bottom:10px;
		.input-box{
			margin-right:10px
		}
		.el-input {
			width: 200px
		}
	}
	.pro-btn-box{
		min-height:40px;
		width:100%;
		display:flex;
		align-items: center;
		flex-direction: row;
		justify-content: space-between;
	}
	.valet-foot{
		height :40px;
		display :flex;
		align-items center;
		justify-content :center
	}
	.container-box1{
		width: 100%;
		height: 250px;
		margin-top: 10px;
		display: flex;
		flex-direction: column;
	}
	.row-box{
		height: 40px;
		display: flex;
		flex-direction: row;
		width: 80%;
		margin-left: 10%;
		align-items: center;
	}
}

</style>
<style lang="stylus">
.gift-body {
	.radioClass {
		.el-radio__label{
			display:none
		}
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-dialog__body{
		padding:10px 20px 0px 20px
	}
	.cell{
		padding :0px !important
	}
}
</style>
